import { SvgIcon, SvgIconProps } from "@mui/material";
import { AlphaGlyphFull, AlphaPlusFull } from "src/components/icons-mui/alpha-icon-glyph";

interface IIconAlphaStrongProps extends SvgIconProps {
    hideBorder?: boolean;
}

export const IconAlphaStrong = ({ hideBorder, ...props }: IIconAlphaStrongProps) => (
    <SvgIcon {...props} viewBox={hideBorder ? "4.6 0 14.4 24" : "0 0 24 24"}>
        {!hideBorder && <rect x="0.3" y="0.3" width="23.4" height="23.4" rx="11.7" stroke="#179C5F" strokeWidth="0.6" fill="none" />}
        <g clipPath="url(#clip0_alpha_strong)">
            <AlphaGlyphFull />
            <AlphaPlusFull />
        </g>
        <defs>
            <clipPath id="clip0_alpha_strong">
                <rect width="14.4" height="14.4" fill="white" transform="translate(4.60156 4.6001)" />
            </clipPath>
        </defs>
    </SvgIcon>
);
